module.exports = __webpack_public_path__ + "media/images/contacto/social-a2ec0b92dcc920ddd925bc1dce0ad848.svg";